import React from 'react';

import Button from '@/core/components/Button';
import { ToastStatus } from '@/core/components/Toast/Toast';
import Actions from '@/core/lib/new-architecture/actions';
import { useToastContext } from '@/core/lib/toast/toast.context';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface UnblockProfileFormProps {
  uuid: string;
  onClose: () => void;
  showToast?: boolean;
}

export const UnblockProfileForm: React.FC<UnblockProfileFormProps> = ({ uuid, onClose, showToast }) => {
  const { t } = useTranslationContext(['profile.actions']);
  const toast = useToastContext();

  const onSuccess = () => {
    onClose();
    if (showToast) {
      toast?.open(t('unblock.success', { ns: 'profile.actions' }), 2000, ToastStatus.SUCCESS);
    }
  };

  const { onSubmit, isLoading } = Actions.user.useUnblock({ onSuccess });

  const onClick = () => onSubmit(uuid);

  return (
    // eslint-disable-next-line
    <div className="flex flex-col gap-6 pt-3 text-center" onClick={e => e.stopPropagation()}>
      <p className="text-body-secondary text-center font-medium text-content-primary">{t('unblock.subtitle', { ns: 'profile.actions' })}</p>
      <div className="grid grid-cols-2 gap-4">
        <div className="col-span-1">
          <Button onClick={onClose} variant="secondary" size="medium">
            {t('unblock.cancel', { ns: 'profile.actions' })}
          </Button>
        </div>
        <div className="col-span-1">
          <Button onClick={onClick} isLoading={isLoading} size="medium">
            {t('unblock.submit', { ns: 'profile.actions' })}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnblockProfileForm;
